(function() {
  'use strict';

  angular
    .module('factories.frameStateProgressHelper', ['factories.authProvider'])
    .factory('FrameStateProgressHelper', FrameStateProgressHelper);

  FrameStateProgressHelper.$inject = ['$timeout', 'ContentPlayerService', 'Auth'];

  function FrameStateProgressHelper($timeout, ContentPlayerService, Auth) {
    var frameStateProgressHelper;
    var getProgressFunction;
    var timerPromise;
    var intervalSeconds = 30;
    var totalTime = 0;
    var cModuleId;
    var frameId;
    var initialProgress;

    function instantiateHelper() {
      frameStateProgressHelper = {
        setup: setup,
        destroy: destroy,
        updateProgress: updateProgress
      }
    }

    function setup(params, fn) {
      destroy();
      cModuleId = params.cModuleId;
      frameId = params.frameId;
      initialProgress = params.initialProgress;
      totalTime = initialProgress;
      getProgressFunction = fn;
      setupTimer();
    }

    function destroy() {
      if (timerPromise)
        $timeout.cancel(timerPromise);
      timerPromise = null;
      cModuleId = null;
      frameId = null;
      initialProgress = 0;
      getProgressFunction = null;
      totalTime = 0;
    }

    function updateProgress(progress) {
      if (!Auth.userIsLoggedIn()) {
        // If user's somehow been logged out before this was destroyed don't bother trying to call the service
        // It will just error. Also destroy the timer.
        destroy();
        return;
      }

      if (progress == null || progress == undefined) {
        if (getProgressFunction && typeof(getProgressFunction) == "function") {
          progress = Math.max(getProgressFunction(), initialProgress);
        } else {
          totalTime = totalTime + intervalSeconds;
          progress = totalTime;
        }
      }

      if (progress && cModuleId && frameId)
        ContentPlayerService.updateFrameProgress(cModuleId, frameId, progress);
    }

    function setupTimer() {
      timerPromise = $timeout(function() {
        updateProgress();
        setupTimer();
      }, intervalSeconds * 1000);
    }

    if (!frameStateProgressHelper)
      instantiateHelper();

    return frameStateProgressHelper;
  }
})();
